export default __webpack_public_path__ + "static/media/안주4.5ca7071d.png";